import BaseObject from '../../../../base/base_object';
import Model from './touch_id_model';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import _ from '../../../../utils/underscore';
import {TOUCH_ID} from './touch_id_consts';
import OptionsComponentController from '../../../../components/options/options_component_controller';
import {TOUCH_ID_SCREENS} from '../../../../components/options/option_components/touch_id/touch_id_component_consts';
import {PRIORITY_LEVEL} from '../../../overlay_manager/overlay_manager_levels';
import ServiceFactory from '../../../service_factory';
import DOM from '../../../../utils/dom';
import {CGP_ERROR_CODES} from '../../../../exceptions/cgp_error_codes';
import {WEB_LOGIN_MODES} from "../../../web_login/web_login_consts";

/**
 *
 *
 */
class TouchID extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'TouchID';

    _model = null;
    _HybridService = null;
    _TouchIdComponentController = null;

    init(params) {
        super.init();

        this._model = Model.create(params);

        this._subscribe();
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;

        const displayAlsoFaceId = this._model.isDisplayAlsoFaceId();

        this._HybridService.setSupportedFaceId(displayAlsoFaceId);

        return this;
    }


    _subscribe() {
        if (this._model.isFeatureEnable()) {
            Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, this.initComplete, this);
            Event.on(SYSTEM_EVENTS.ON_RUN_AUTOLOGIN, this._onAutoLogin, this);
            Event.on(SYSTEM_EVENTS.SUCCESSFULLY_LOGIN_RESPONSE, this._successLogin, this);
            Event.on(SYSTEM_EVENTS.FAIL_LOGIN_RESPONSE, this._failLogin, this);
            Event.on(SYSTEM_EVENTS.TOUCH_ID_GET_TOKEN_FROM_SRV, this.getTokenFromSrv, this);
            Event.on(SYSTEM_EVENTS.TOUCH_ID_INIT_SCREEN_SHOW, this.setInitScreenShowed, this);
            Event.on(SYSTEM_EVENTS.TOUCH_ID_CHECK_TOKEN_ENABLE, this.getTokenAndCheckEnable, this);
            Event.on(SYSTEM_EVENTS.TOUCH_ID_CLEAR_TOKEN, this.clearToken, this);
            Event.on(SYSTEM_EVENTS.TOUCH_ID_LOGIN_ERROR, this.loginerror, this);
            Event.on(TOUCH_ID_SCREENS.TOUCH_ID_CTL_OPENED, this._touchCtlOpend, this);
            Event.on(TOUCH_ID_SCREENS.TOUCH_ID_CTL_CLOSED, this._touchCtlClosed, this);
            Event.on(SYSTEM_EVENTS.LOGIN_FORM_OPEN, this._triggerFitToPlayOrLogin, this);
            Event.on(SYSTEM_EVENTS.TOUCH_ID_AUTO_LOGIN, this._touchIdAutoLoginOnInit, this);
        }
    }


    initComplete() {
        Event.fire(SYSTEM_EVENTS.TOUCH_GT_SET_ENABLE,true);
    }

    /**
     * perform action when we have an error at the login with the tocuh id.
     */
    loginerror(error) {
        switch (error) {
            case CGP_ERROR_CODES.TOKEN_NOT_VALID:
                let bVal = this._model.isloginWithTouch();
                this._model.setloginWithTouch(false);
                if (bVal) {
                    this.clearAll();
                }
                break;
            default:
                // maybe should throw an Exception here
                break;
        }
    }

    /**
     * clear the token in hybrid
     */
    clearToken() {
        this._HybridService.clearToken();
    }

    getModel() {
        return this._model;
    }

    _touchIdAutoLoginOnInit(params){
        if (this._model.isFeatureEnable() && !this._HybridService.serviceFactory.oAuth2Service().isAuthorized()) {
            this._triggerFitToPlayOrLogin(params);
        }
    }

    _touchCtlClosed() {
       // this._HybridService.setRotaion(ROTATION_KEYS.ALL, 'true');
    }
    _touchCtlOpend() {
       // this._HybridService.setRotaion(ROTATION_KEYS.PORTRATE, 'true');
    }
    setInitScreenShowed() {
        this._model.setInitScreenShowed('true');
    }

    _triggerFitToPlayOrLogin(params = {}) {
        const fitToPlayEnabled = this._HybridService.serviceFactory.regulationService().fitToPlayModeEnabled();

        if(fitToPlayEnabled && params.fitToPlaySubmit !== true){
            this._getTouchIdToken().then(() => {
                this._HybridService.serviceFactory.webLoginService().updateLoginFormModeType(WEB_LOGIN_MODES.FIT_TO_PLAY);
            });
        }else{
            this.triggerTouchIdLogin();
        }
    }

    _getTouchIdToken(){
        return new Promise((resolve, reject) => {
            this._HybridService.getTouchIdToken().then(data => {
                this._model.setTokenData(data);
                if (this._model.isTokenEnable()) {
                    resolve(data);
                }else{
                    reject();
                }
            });
        });
    }

    /**
     * check if we need to display the touch id for the user to login with his finger print
     */
    triggerTouchIdLogin() {
        this._getTouchIdToken().then(() => {
            this.callOpenTouchId().then(data =>
                this._loginWithToken(_.safeJSONandDecode(data))
            ).then(() => {
                Event.fire(SYSTEM_EVENTS.TOUCH_ID_STATE_CHANGED);
            });
        });
    }

    /**
     * login with the token that was save in the hybrid
     */
    _loginWithToken(json) {
        this._model.setResTouchParams(json);
        if (this._model.isSuccess()) {
            this._HybridService.getParamsForToken()
                .then(data => {
                    this._model.saveParamsForToken(data);
                    this._model.setloginWithTouch(true);
                    let params = JSON.stringify(this._model.getParamsForLogin());
                    Event.fire(SYSTEM_EVENTS.RUN_AUTOLOGIN_TOUCH_ID, params);
                });
        }
    }

    /**
     * fail to Login - update analitic
     */
    _failLogin() {
        let bVal = this._model.isloginWithTouch();
        DOM.setTimeout(() => {
            this._model.setloginWithTouch(false);
        }, 2000);
        if (true === bVal) {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_TouchID', action: 'LoginFailure'});
        }
    }

    _onAutoLogin() {
        this._model.setAutoLogin(true);
    }

    _successLogin(cidData) {
        // this._HybridService.setRotaion(ROTATION_KEYS.ALL, 'true');
        // users with auto login - are returned - to avoid executing the following code - to prevent first time logins from running.
        // autologin is usually indicates the user is firstly login - except touchid flow which can be called few times
        if (this._model.isAutoLogin()) {
            this.clearAll();
            this._model.setAutoLogin(false);
            return;
        }

        // close the overlay of the login
        //Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: PRIORITY_LEVEL.LOGIN});
        let bVal = this._model.isloginWithTouch();
        this._model.setloginWithTouch(false);
        if (true === bVal) {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_TouchID', action: 'LoginSuccess'});
        }

        // ask for new token for the touch id
        this._checkOtherCid(cidData);
        this._HybridService.getTouchIdToken()
            .then(data => {
                this._model.setTokenData(data);
                if (this._model.canDisplayInitializeScreen()) {
                    this._openController(TOUCH_ID_SCREENS.INIT_SCREEN);
                }
            });
    }

    /**
     * check if the new CID is different from the old one - if yes the clear all data(old token)
     */
    _checkOtherCid(cidData) {
        if (cidData.newCid !== cidData.lastCid) {
            this.clearAll();
        }
    }

    clearAll() {
        this._model.setInitScreenShowed('false');
        this.clearToken();
    }
    /**
     * open Controller to display the touch id
     * screen: there are 3 screens
     * INIT_SCREEN: the outonatic screen after first login
     * MODIFY_SCREEN: the manual screen that we open from the menu
     */
    _openController(screen) {
        this._TouchIdComponentController = this._TouchIdComponentController || OptionsComponentController.create().load('TouchId');
        this._TouchIdComponentController.setScreen(screen);
        this._TouchIdComponentController.render();
    }

    setTouchIdComponentController(control) {
        this._TouchIdComponentController = control;
    }

    /**
     * open TouchId window
     */
    openTouchId() {

        const caption = this._model.getText(TOUCH_ID.KEY_OPEN_NATIVE_TOUCH_TXT);
        return this._HybridService.openTouchId(caption);
    }

    /**
     * get Token And Check Enable - get a new token if the device is enable
     */
    getTokenAndCheckEnable() {
        return this._HybridService.getTouchIdToken().then(data => {
            this._model.setTokenData(data);

            const isTokenAndCheckEnable = this._model.isDeviceTouchEnable() && !this._model.isTokenEmpty(); // check if touch is suported and there is a token

            Event.fire(SYSTEM_EVENTS.TOUCH_ID_TOKEN_ENABLE_RES, isTokenAndCheckEnable);

            return isTokenAndCheckEnable;
        });
    }

    /**
     * get Token From Server and save him in the hybrid
     */
    getTokenFromSrv() {
        return this._HybridService.getParamsForToken()
            .then(data => {
                this._model.saveParamsForToken(data);

                const params = this._model.getParamsForToken();

                // call to SRV
                return ServiceFactory.create().userService().renewLoginToken(params)
                    .then(data => {
                        this._model.setSrvToken(data);

                        const setTokenRes = this._HybridService.setToken(this._model.getSrvToken());
                        Event.fire(SYSTEM_EVENTS.TOUCH_ID_STATE_CHANGED);

                        return setTokenRes;

                    })
                  .catch(error =>{
                    this.logger.error("Retrieve Token For Touch Id failed", error);
                    throw error;
                  });
            });
    }


    /**
     * call Open TouchId - check if the device is support touch id then open the touch id screen
     */
    callOpenTouchId() {
        return this._HybridService.isTouchIdSuported().then(data => {
            this._model.setEnableRes(_.safeJSONandDecode(data));
            if (this._model.isDeviceTouchEnable()) {// check if touch is suported
                return this.openTouchId().then(data => {
                    this._model.setResTouchParams(_.safeJSONandDecode(data));

                    if (this._model.isSuccess()) {
                        this.closeComponentController();
                    } else {
                        this.onTouchVerifyError();
                    }

                    return data;
                });
            } else {
                this.closeComponentController();
            }
        });
    }

    /**
     * display Try Again if the device is support touch id.
     */
    onTryAgain() {

        this._HybridService.isTouchIdSuported().then(data => {
            this._model.setEnableRes(_.safeJSONandDecode(data));
            if (this._model.isDeviceTouchEnable()) {// check if touch is suported
                let txt = this._model.getText(TOUCH_ID.KEY_TRY_AGAIN_TXT);
                let caption = this._model.getText(TOUCH_ID.KEY_TRY_AGAIN_CAPTION);
                let skip = this._model.getText(TOUCH_ID.KEY_BUT_SKIP);
                let tryAgain = this._model.getText(TOUCH_ID.KEY_BUT_TRY_AGAIN);

                Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
                    title: caption, text: txt,
                    priority: PRIORITY_LEVEL.TOUCH_ID_POPUP,
                    customCSSClassList: ['mdp-mobile-full-size'],
                    buttons: [
                        {
                            name: tryAgain,
                            callback: () => {
                                this.callOpenTouchId();
                            }
                        },
                        {
                            name: skip,
                            callback: () => {
                                Event.fire(SYSTEM_EVENTS.TOUCH_ID_TRY_AGAIN_SKIP);
                            }
                        }
                    ]
                });
            } else {
                let txt = this._model.getText(TOUCH_ID.KEY_DISABLE_TXT);
                let skip = this._model.getText(TOUCH_ID.KEY_BUT_DISABLE_OK);

                Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
                    title: '', text: txt,
                    priority: PRIORITY_LEVEL.TOUCH_ID_POPUP,
                    buttons: [{name: skip, callback: () => {
                         this.closeComponentController();
                    }}]
                });
            }
        });
    }

    /**
     * onTouchVerifyError - act accurding to the error from the finger print on the device.
     */
    onTouchVerifyError() {

        let reason = this._model.getReason();

        // this._HybridService.alert(reason.toString());

        let errorlog = '';

        switch (reason) {
            case TOUCH_ID.KEY_EROR_FAILD: // -1
                errorlog = 'Native_Error_Failed';
                this.triggerTouchIdLogin();
                break;
            case TOUCH_ID.KEY_EROR_LOCK_OUT: // -8
                errorlog = 'Native_Lock_Out';
                this.onTryAgain();
                break;
            case TOUCH_ID.KEY_EROR_CANCEL: // -2
                errorlog = 'Cancel_Native_Prompt';
                Event.fire(SYSTEM_EVENTS.TOUCH_ID_TRY_AGAIN_SKIP);
                break;
            default:
                this.closeComponentController();
        }

        if(errorlog.length > 0) {
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {category: 'Client_TouchID', action: errorlog});
        }
    }

    closeComponentController() {
        this._TouchIdComponentController?.close();
    }
}

export default TouchID;
